<script>
  import { format } from 'svelte-i18n';
  import { Button } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { sanitizeParamValue } from '@client/utils/sanitize';

  export let params = [];
  export let framed = true;
  export let onChange = () => {};
  export let namePlaceholder = 'label.NAME';
  export let valuePlaceholder = 'label.VALUE';
  export let editing = true;

  const addParam = () => {
    params.push({
      name: '',
      value: ''
    });

    params = [...params];

    onChange(params);
  };

  const removeField = (index) => {
    const removed = params.splice(index, 1);
    params = [...params];

    onChange(params, removed);
  };

  const onBlur = () => {
    onChange(params);
  };
</script>

<div class="fields" class:framed>
  {#each params as config, index}
    <div class="field columns">
      {#if editing}
        <input
          type="text"
          class="name"
          placeholder={$format(namePlaceholder)}
          bind:value={config.name}
          on:blur={onBlur}
          on:keyup={() => (config.name = sanitizeParamValue(config.name))}
        />
        <input
          type="text"
          class="value"
          placeholder={$format(valuePlaceholder)}
          bind:value={config.value}
          on:blur={onBlur}
          on:keyup={() => (config.value = sanitizeParamValue(config.value))}
        />
      {:else}
        <div class="name">{config.name}</div>
        <div class="value">{@html config.value || '&nbsp;'}</div>
      {/if}
      <Icon name="trash" class="pointer" on:click={() => removeField(index)} />
    </div>
  {/each}

  <Button color="secondary" size="sm" class="pointer {params.length ? 'mt-3' : ''}" on:click={addParam}>
    <Icon name="plus" />
    <span>{$format('label.PARAM')}</span>
  </Button>
</div>

<style lang="scss" src="./query-params.scss"></style>
